/** Formata preço em reais: 50000 → "R$ 50.000" */
export const formatPrice = (price: string | number | null | undefined): string => {
  if (price == null || price === '') return '';
  return `R$ ${Math.trunc(Number(price)).toLocaleString('pt-BR')}`;
};

/** Formata quilometragem: 45000 → "45.000 Km" */
export const formatOdometer = (odometer: string | number | null | undefined): string => {
  if (odometer == null || odometer === '') return '';
  return `${Math.trunc(Number(odometer)).toLocaleString('pt-BR')} Km`;
};

/** Formata telefone: "11999998888" → "(11) 99999-8888" */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = /^(\d{2})(\d{4,5})(\d{4})$/.exec(cleaned);
  if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  return 'Telefone não compartilhado';
};
